export default __webpack_public_path__ + "static/media/hero-bg-p.a87b7b57.jpg";